import React from "react";

const getIngredientCost = (name, amountInGrams, menu) => {
  const item = menu.find(item => item.name.toLowerCase().trim() === name.toLowerCase().trim());
  if (!item || typeof item.pricePerKg === "undefined") {
    console.warn(`⚠️ Missing ingredient or price for: ${name}. Ensure it's in Firestore.`);
    return 0;
  }
  return (parseFloat(item.pricePerKg) / 1000) * amountInGrams;
};

export const calculateSavoryCrepeCost = (type, menu) => {
  let baseCost = getIngredientCost("Dough", 85, menu) +
                 getIngredientCost("Water", 85, menu);
  
  if (type === "Triple Cheese Crepe") {
    baseCost += getIngredientCost("Mozzarella", 35, menu) +
                getIngredientCost("Ach2awen", 30, menu) +
                getIngredientCost("Akkawi", 25, menu) +
                getIngredientCost("Ketchup", 15, menu);
  }
  
  if (type === "Pizza Crepe") {
    baseCost += getIngredientCost("Mozzarella", 30, menu) +
                getIngredientCost("Ach2awen", 30, menu) +
                getIngredientCost("Habach", 40, menu) +
                getIngredientCost("Corn", 20, menu) +
                getIngredientCost("Ketchup", 15, menu);
  }

  return baseCost;
};

const SavoryCrepeCostCalculator = ({ menu }) => {
  return (
    <div className="mt-10 p-6 bg-gray-900 rounded-lg">
      <h2 className="text-2xl font-bold mb-4">Savory Crepe Cost Calculator</h2>
      {["Triple Cheese Crepe", "Pizza Crepe"].map((type) => (
        <div key={type} className="mb-2">
          <h3>{type}: ${calculateSavoryCrepeCost(type, menu).toFixed(2)}</h3>
        </div>
      ))}
    </div>
  );
};

export default SavoryCrepeCostCalculator;

